import { ApiFunc, getInstance } from '@helpers/httpClient'

import * as API from '../constants/api'

const instance = getInstance()

export const attendance: ApiFunc<`${typeof API.ATTENDANCE}`, 'post'> = data => instance.post(API.ATTENDANCE, data)

export const attendanceCsv: ApiFunc<`${typeof API.ATTENDANCE_CSV}`, 'post'> = data =>
  instance.post(API.ATTENDANCE_CSV, data)

export const attendanceGroup: ApiFunc<`${typeof API.ATTENDANCE_GROUP}`, 'get'> = data =>
  instance.get(API.ATTENDANCE_GROUP, {
    params: data,
  })

export const attendanceTable: ApiFunc<`${typeof API.ATTENDANCE_TABLE}`, 'get'> = data =>
  instance.get(API.ATTENDANCE_TABLE, {
    params: data,
  })

export const attendanceTableStudent: ApiFunc<`${typeof API.ATTENDANCE_TABLE_STUDENT}`, 'get'> = data =>
  instance.get(API.ATTENDANCE_TABLE_STUDENT, {
    params: data,
  })

export const attendanceTableStudentList: ApiFunc<`${typeof API.ATTENDANCE_TABLE_STUDENT_LIST}`, 'get'> = data =>
  instance.get(API.ATTENDANCE_TABLE_STUDENT_LIST, {
    params: data,
  })

export const attendanceTableModule: ApiFunc<`${typeof API.ATTENDANCE_TABLE_MODULE}`, 'get'> = data =>
  instance.get(API.ATTENDANCE_TABLE_MODULE, {
    params: data,
  })

export const attendanceFaceIds: ApiFunc<`${typeof API.ATTENDANCE_FACE_ID_ALL}`, 'get'> = data =>
  instance.get(API.ATTENDANCE_FACE_ID_ALL, {
    params: data,
  })

export const attendanceUpload: ApiFunc<`${typeof API.ATTENDANCE_FACE_ID_IMPORT}`, 'post'> = data =>
  instance.post(API.ATTENDANCE_FACE_ID_IMPORT, data as unknown as FormData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
